interface PortalRootProps {
  id: string;
  className?: string;
  style?: React.CSSProperties;
  zIndex?: number;
}

export const PortalRoot = ({
  id,
  className,
  style,
  zIndex = 3000,
}: PortalRootProps) => {
  return (
    <div
      id={id}
      className={className}
      style={{
        pointerEvents: "none",
        position: "fixed",
        inset: 0,
        zIndex: zIndex,
        ...style,
      }}
    />
  );
};
